// src/features/auth/authApi.ts
import { api } from '@/store/api'
import type { AuthTokens, IUser } from '@/types/auth'
import type { Lang } from '@/types/lang'

export const authApi = api.injectEndpoints({
  endpoints: (build) => ({
    obtainToken: build.mutation<AuthTokens, string>({
      query: (idToken) => ({
        url: 'users/token/obtain',
        method: 'GET',
        headers: { Authorization: idToken },
      }),
      invalidatesTags: ['Me'],
    }),
    refreshToken: build.mutation<AuthTokens, string>({
      query: (refreshToken) => ({
        url: 'users/token/refresh',
        method: 'GET',
        headers: { Authorization: refreshToken },
      }),
    }),
    me: build.query<IUser, void>({
      query: () => 'users/me',
      providesTags: ['Me'],
    }),
    patchMe: build.mutation<void, { languageCode: Lang } | { country: string }>({
      // Ручка частичная: шлём РОВНО одно поле, тело — аргумент как есть.
      // `country` вдобавок включает флаг «страна задана вручную» и выключает
      // автоопределение по IP — поэтому синхронизация языка его не шлёт, а
      // выбор страны в настройках шлёт только его (PRD #71, п.28).
      query: (body) => ({ url: 'users/me', method: 'PATCH', body }),
      invalidatesTags: ['Me'],
    }),
    /**
     * Контактная почта — ОТДЕЛЬНАЯ ручка, а не поле `PATCH users/me`: её же
     * зовёт боевой плеер (`patchContactEmail`), и тело у неё snake_case
     * (`contact_email`), хотя ответ `users/me` приезжает camelCase. Инвалидация
     * `Me` тут не косметика: от прочитанного профиля зависит доступность
     * рублёвой оплаты (`useCardPaymentAccess`), и способ обязан появиться сам.
     */
    patchContactEmail: build.mutation<void, string>({
      query: (contactEmail) => ({
        url: 'users/me/contact-email',
        method: 'PATCH',
        body: { contact_email: contactEmail },
      }),
      invalidatesTags: ['Me'],
    }),
  }),
})

// useMeQuery deliberately not re-exported: fetch /users/me via useMe(), which
// guards against firing the request without a token.
export const { useObtainTokenMutation, usePatchMeMutation, usePatchContactEmailMutation } = authApi
